import React, { Component } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faPlus } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { TextField } from "../common/FormComponents";
import { userSelector } from '../redux/selectors';
import { toArray } from "../common/util";
import { AutoComplete } from "../common/FormComponents";

const validate = values => {
    const errors = {};

    if (!values.amount) {
        errors.amount = '* Required'
    }

    if (!values.user) {
        errors.user = '* Required'
    }

    return errors;
};


class ResourceContributionForm extends Component {
    render() {
        const { handleSubmit, addToggle, editToggle } = this.props;
        function submit(event) {
            handleSubmit();
            if (addToggle)
                addToggle();
            if (editToggle)
                editToggle();
        }
        return (
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col md={2}>
                        <Field component={AutoComplete}
                            name="user"
                            type="text"
                            label="Member"
                            completeField="displayName"
                            suggestions={toArray(this.props.users)}
                            onChange={this.handleChange}
                            helperText={<span />}
                        />
                    </Col>
                    <Col md={2}>
                        <Field component={TextField}
                            name="amount"
                            type="text"
                            label="Amount"
                            onChange={this.handleChange}
                            helperText={<span />}
                        />
                    </Col>
                    <Col md={2}>
                        <Field component={TextField}
                            name="description"
                            type="text"
                            label="Description"
                            onChange={this.handleChange}
                            helperText={<span />}
                        />
                    </Col>
                    <Col md={2}>
                        <Field component={TextField}
                            name="dkp"
                            type="text"
                            label="DKP"
                            onChange={this.handleChange}
                            helperText={<span />}
                        />
                    </Col>
                    <Col md={2}>
                        <Button disabled={this.props.pristine || this.props.pending} onClick={submit}>
                            {(this.props.pending) ? (
                            <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                            ) : (null)}
                            <FontAwesomeIcon className="text-primary" icon={faPlus} fixedWidth /> {this.props.new ? ('Add') : ('Edit')} Resource Contribution
                        </Button>
                    </Col>
                </Row>
            </Form>
        )
    }
}

const mapStateToProps = (state) => ({
    users: userSelector(state),
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({ validate, })(ResourceContributionForm))


// WEBPACK FOOTER //
// ./src/Officer/ResourceContributionForm.js